import { trackClick, trackCustom } from '../tracking'

const trackWithGroupAction = (
  name: string,
  type: 'upselling' | 'crossselling',
  context?: Record<string, unknown>
) => {
  trackCustom(`recommendation-${type}-product-interaction`, context)
  trackClick(name, context)
}

export const getTrackingOptions = (type: 'upselling' | 'crossselling') => ({
  onAddToCart: (sapId) =>
    trackWithGroupAction(`recommendation-${type}-add-product-to-cart`, type, { sapId }),
  onAddToTemplate: (sapId) =>
    trackWithGroupAction(`recommendation-${type}-add-product-to-template`, type, { sapId }),
  onLinkClick: (sapId) =>
    trackWithGroupAction(`recommendation-${type}-navigate-to-product-details`, type, { sapId }),
  onSwipeLeft: () => trackClick(`recommendation-${type}-swiper-left`),
  onSwipeRight: () => trackClick(`recommendation-${type}-swiper-right`),
})
